
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kursy",
      function () {
        return require("private-next-pages/kursy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kursy"])
      });
    }
  